// import { addFilter, applyFilters } from '@wordpress/hooks';
import appmaker from '@appmaker/core/index';
import ShopifyInstall from './components/ShopifyInstall'
import { sendAppmakerEvent } from '@appmaker/core/api/events';

// App Bridge v4: Initialization is now handled automatically by the CDN script in index.html
// The global `window.shopify` object is created by the script tag
// Session tokens are retrieved via window.shopify.idToken() when needed

const CoreApp = {
	id: '@appmaker/core-app',
	name: 'Core app',
	activate: () => {
		appmaker.registerRootRoute({ routeName: '/shopify-install', component: ShopifyInstall });
		appmaker.onTrack(({ event, params }) => {
			sendAppmakerEvent(event, params)
		})

	},
};

export default CoreApp;
